export default {
  CONSTRUCT() {
    return {
      visible: false,
      message: 'hello world!!!',
      action: 'Info'
    };
  },
  SHOW_SNACKBAR(state, data) {
    let next = state;
    if (data.message) {
      next = next.set('message', data.message);
    }
    if (data.action) {
      next = next.set('action', data.action);
    }
    return next.set('visible', true);
  },
  HIDE_SNACKBAR(state) {
    return state.set('visible', false);
  }
};
